module.exports = __webpack_public_path__ + "static/007455-7bcf25a83b5d0047d35b854d29ca1667.jpg";